const AL_ANFAR_PRICE_PATTERNS = [
  /Dhs\.\s*([\d,]+)(?:\.(\d{1,2}))?\s*(?:AED)?/gi,
  /AED\s*(?:USD\s*|US\$\s*|\$\s*)?([\d,]+)(?:\.(\d{1,2}))?/gi,
  /([\d,]+)(?:\.(\d{1,2}))?\s*AED/gi,
  /(?:USD\s*|US\$\s*|\$\s*)([\d,]+)(?:\.(\d{1,2}))?/gi,
];

function formatAlAnfarAmount(whole, decimals = '') {
  const numeric = Number(String(whole).replaceAll(',', '') + (decimals ? `.${decimals}` : ''));
  if (!Number.isFinite(numeric)) return `AED ${whole}`;
  return `AED ${Math.round(numeric).toLocaleString('en-US')}`;
}

function normalizeAlAnfarPriceText(value) {
  if (!value || !/(?:Dhs\.|AED|USD|US\$|\$)/i.test(value)) return value;

  return AL_ANFAR_PRICE_PATTERNS.reduce(
    (result, pattern) => result.replace(pattern, (_match, whole, decimals) => formatAlAnfarAmount(whole, decimals)),
    value
  );
}

function normalizeAlAnfarPriceNode(root) {
  if (!root || root.nodeType === Node.COMMENT_NODE) return;

  if (root.nodeType === Node.TEXT_NODE) {
    const normalized = normalizeAlAnfarPriceText(root.nodeValue);
    if (normalized !== root.nodeValue) root.nodeValue = normalized;
    return;
  }

  if (!(root instanceof Element) || root.matches('script, style, template, svg')) return;

  for (const attribute of ['aria-label', 'title']) {
    const current = root.getAttribute(attribute);
    if (!current) continue;
    const normalized = normalizeAlAnfarPriceText(current);
    if (normalized !== current) root.setAttribute(attribute, normalized);
  }

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      return node.parentElement?.closest('script, style, template, svg')
        ? NodeFilter.FILTER_REJECT
        : NodeFilter.FILTER_ACCEPT;
    },
  });

  while (walker.nextNode()) normalizeAlAnfarPriceNode(walker.currentNode);
}

function initializeAlAnfarPriceFormat() {
  normalizeAlAnfarPriceNode(document.body);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'characterData') normalizeAlAnfarPriceNode(mutation.target);
      for (const node of mutation.addedNodes) normalizeAlAnfarPriceNode(node);
    }
  });

  observer.observe(document.body, { childList: true, characterData: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAlAnfarPriceFormat, { once: true });
} else {
  initializeAlAnfarPriceFormat();
}
